export default {"src":"/_next/static/media/blue-loading.037c23d5.svg","height":97,"width":97,"blurWidth":0,"blurHeight":0};